import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"
import _imports_0 from '@/assets/images/shareIcons/play_pause_rectangle.svg'


const _hoisted_1 = {
  key: 0,
  class: "h-full w-full modal-wrapper content-transparent modal-mask"
}
const _hoisted_2 = { class: "modal-container w-full" }
const _hoisted_3 = { class: "content-scroll flex-container" }
const _hoisted_4 = { class: "left-panel pright-10 col gap-15" }
const _hoisted_5 = { class: "text-lg font-semibold mb-2 mbottom-02" }
const _hoisted_6 = { class: "right-panel" }
const _hoisted_7 = { class: "video-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "vimeo-container"
}
const _hoisted_9 = ["src", "title"]
const _hoisted_10 = {
  key: 1,
  class: "empty-state"
}

import { ref, onMounted, computed } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

interface Video {
  title: string;
  vimeoId: string;
}

interface TutorialGroup {
  title: string;
  videos: Video[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'onboardingTutorialsEmbed',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const target = ref(null);

const tutorialGroups = ref<TutorialGroup[]>([
  {
    title: "Débuter",
    videos: [
      {title: "Créer un patient", vimeoId: "1124391339"},
      {title: "Rajouter antécédents", vimeoId: "1124392942"},
      {title: "Rajouter traitements", vimeoId: "1124404698"},
      {title: "Faire consultation", vimeoId: "1124404710"},
      {title: "Créer titre pour un groupe", vimeoId: "1124404728"},
      {title: "Prescrire bio medic et imagerie", vimeoId: "1124404575"},
      {title: "Faire ordonnance bio", vimeoId: "1124404595"},
      {title: "Faire ordonnance pharmacie", vimeoId: "1124404604"},
      {title: "Rajouter écosystème", vimeoId: "1124404618"},
      {title: "Rajouter 2e groupe", vimeoId: "1124404629"},
      {title: "Prescrire depuis conclusion", vimeoId: "1124404640"},
      {title: "MH avec PID", vimeoId: "1124404672"},
      {title: "MH avec annulation", vimeoId: "1124404686"},
    ]
  },
  {
    title: "Comptabilité",
    videos: [
      {title: "Valider un MH par PID ou RA", vimeoId: "1126012257"},
      {title: "Marquer MH comme non payé et imprimer", vimeoId: "1126012267"},
      {title: "Chercher MH et valider comme virement", vimeoId: "1126012285"},
      {title: "Valider MH par carte bancaire", vimeoId: "1126012308"},
      {title: "Annuler un MH", vimeoId: "1126012330"},
      {title: "Supprimer une transaction", vimeoId: "1126012354"},
      {title: "Modifier une transaction", vimeoId: "1126012367"},
      {title: "Filtrer par date et patient", vimeoId: "1126012391"},
      {title: "Rajouter une note au MH", vimeoId: "1126012409"},
      {title: "Exporter données comptables", vimeoId: "1126012426"},
    ]
  },
  {
    title: "Paramétrage ordonnances",
    videos: [
      {title: "Ordonnances - En-tête médecin", vimeoId: "1126442928"},
      {title: "Ordonnances - En-tête institut", vimeoId: "1126442944"},
    ]
  },
  {
    title: "Paramétrage comptabilité",
    videos: [
      {title: "Créer groupe financier", vimeoId: "1126442953"},
      {title: "Créer canaux financiers", vimeoId: "1126442972"},
      {title: "Régler accès du groupe financier", vimeoId: "1126442996"},
    ]
  },
  {
    title: "Paramétrage agenda",
    videos: [
      {title: "Créer salles d'attente", vimeoId: "1126443002"},
      {title: "Régler durée des RdV et accès", vimeoId: "1126443019"},
      {title: "Créer RdV type", vimeoId: "1126443043"},
      {title: "Créer journée type", vimeoId: "1126443057"},
      {title: "Créer journées spéciales", vimeoId: "1126443077"},         
    ]
  },     
  {
    title: "Personnalisation",
    videos: [
      {title: "Créer fiche (ECG)", vimeoId: "1126553242"},
      {title: "Renouv.ordonnance - exemple", vimeoId: "1126553256"},
      {title: "Renouv.ordonnance - config", vimeoId: "1126553265"},
      {title: "Gastro-entérite - exemple", vimeoId: "1126553271"},
      {title: "Gastro-entérite - config", vimeoId: "1126553288"},
      {title: "Suivi adulte - exemple", vimeoId: "1126553300"},
      {title: "Suivi adulte - config", vimeoId: "1126553313"},
      {title: "Configurer signes clinique", vimeoId: "1126553319"},
      {title: "Configurer listes bio", vimeoId: "1126553327"},
      {title: "Configurer défauts d'un document", vimeoId: "1126553334"},
    ]
  }
]);

const selectedTutorial = ref<{ video: Video; groupIndex: number; videoIndex: number } | null>(null);
const isInitialLoad = ref(true);

const { t } = useI18n();

onClickOutside(target, () => emit('modal-close'));

const buildVimeoUrl = (vimeoId: string): string => {
  const autoplayParam = isInitialLoad.value ? '' : '&autoplay=1&muted=1';
  return `https://player.vimeo.com/video/${vimeoId}?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479${autoplayParam}`;
};

const selectedVideoUrl = computed(() => {
  if (selectedTutorial.value?.video?.vimeoId) {
    return buildVimeoUrl(selectedTutorial.value.video.vimeoId);
  }
  return null;
});

const getGroupPrefix = (index: number): string => {
  return String.fromCharCode(65 + index); // 65 is ASCII for 'A'
};

const getGroupDisplayTitle = (group: TutorialGroup, index: number): string => {
  return `${getGroupPrefix(index)}) ${group.title}`;
};

const getVideoDisplayTitle = (video: Video, index: number): string => {
  return `${index + 1} ${video.title}`;
};

const selectTutorial = (video: Video, groupIndex: number, videoIndex: number) => {
  isInitialLoad.value = false;
  selectedTutorial.value = { video, groupIndex, videoIndex };
};

const isSelected = (groupIndex: number, videoIndex: number): boolean => {
  return selectedTutorial.value?.groupIndex === groupIndex && 
         selectedTutorial.value?.videoIndex === videoIndex;
};

onMounted(() => {
  if (tutorialGroups.value.length > 0 && tutorialGroups.value[0].videos.length > 0) {
    // Set initial video without triggering autoplay
    selectedTutorial.value = { 
      video: tutorialGroups.value[0].videos[0], 
      groupIndex: 0, 
      videoIndex: 0 
    };
  }
});


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_listGroup2 = _resolveComponent("listGroup2")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "target",
            ref: target,
            class: "es-tab-settings flex-col"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tutorialGroups.value, (group, groupIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: groupIndex,
                    class: "mb-6"
                  }, [
                    _createElementVNode("h4", _hoisted_5, _toDisplayString(getGroupDisplayTitle(group, groupIndex)), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.videos, (video, videoIndex) => {
                      return (_openBlock(), _createBlock(_component_listGroup2, {
                        key: videoIndex,
                        styles: "pad-s",
                        class: _normalizeClass(["row gap-05 pleft-04", isSelected(groupIndex, videoIndex) ? 'shadow-txt' : '']),
                        onClick: ($event: any) => (selectTutorial(video, groupIndex, videoIndex))
                      }, {
                        default: _withCtx(() => [
                          _cache[0] || (_cache[0] = _createElementVNode("img", {
                            src: _imports_0,
                            alt: "play_pause_rectangle"
                          }, null, -1)),
                          _createVNode(_component_text_item, {
                            txt: getVideoDisplayTitle(video, videoIndex),
                            styles: "font-m main-m",
                            style: {"max-width":"250px"}
                          }, null, 8, ["txt"])
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"]))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (selectedVideoUrl.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("iframe", {
                          src: selectedVideoUrl.value,
                          frameborder: "0",
                          allow: "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share",
                          referrerpolicy: "strict-origin-when-cross-origin",
                          title: selectedTutorial.value.video.title
                        }, null, 8, _hoisted_9)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("p", null, _toDisplayString(_unref(t)('menu.tutorial.selectVideo')), 1)
                      ]))
                ])
              ])
            ])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})